export function isDirty<T extends object>(sourceData: T, data: T) {
  if (Object.keys(sourceData).length !== Object.keys(data).length) {
    return true;
  }
  for (const key in sourceData) {
    const sourceValue = sourceData[key];
    const value = data[key];
    if (
      typeof sourceValue !== typeof value ||
      ((typeof sourceValue !== "object" || sourceValue === null || value === null) && sourceValue !== value) ||
      (sourceValue instanceof Date && value instanceof Date && sourceValue.getTime() !== value.getTime()) ||
      (typeof sourceValue === "object" && sourceValue && value && isDirty(sourceValue, value))
    ) {
      return true;
    }
  }
  return false;
}
